import { canv } from "@/canv/global";
import { toolBase } from "@/tools/toolBase";

export class StickersTool extends toolBase {
    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.4 14.6999C8.81916 15.2588 9.36269 15.7124 9.98754 16.0248C10.6124 16.3372 11.3014 16.4999 12 16.4999C12.6986 16.4999 13.3876 16.3372 14.0125 16.0248C14.6373 15.7124 15.1808 15.2588 15.6 14.6999M13.8 10.1999C14.475 9.2999 15.825 9.2999 16.5 10.1999M10.2 10.1999C9.525 9.2999 8.175 9.2999 7.5 10.1999" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;
    }

    getToolTipName() {
        return "Эмодзи и стикеры";
    }

    select() {
        super.select();
        canv.appInterface.stickersWindow.open();
    }

    unselect() {
        super.unselect();
        canv.appInterface.stickersWindow.close();
    }

    name = "stickersTool";
}
